import { BaseBreakpointConfig } from '@chakra-ui/theme-tools';

/**
 * Breakpoints for responsive design
 */
const breakpoints: BaseBreakpointConfig = {
  sm: '30em',
  md: '48em',
  lg: '62em',
  xl: '80em',
};

export default breakpoints;
